const sectionCardMultiToolCss = `
[data-type='section-card-multi-tool'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-card-multi-tool'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-multi-tool'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-multi-tool'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-multi-tool'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-card-multi-tool'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left[data-style-center-y='true'] {
  justify-content: center;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 40px;
  border: solid 1px #d4dceb;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated {
  display: flex;
  gap: 8px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content {
  margin-bottom: 20px !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h1,
[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h2,
[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
  font-size: 16px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .card-content p {
  margin-bottom: 0;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion {
  border-bottom: solid 1px #d4dceb;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  cursor: pointer;
  font-weight: bold;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-title div:first-child {
  width: calc(100% - 25px);
  font-size: 16px;
  font-weight: bold !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child {
  display: flex;
  border-radius: 50%;
  background-color: #000000;
  color: #ffffff;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child svg {
  display: block;
  width: 18px;
  height: auto;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child.open {
  transform: rotate(-180deg);
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-content {
  max-height: 0;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-accordion .accordion-content .accordion-text {
  padding: 10px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small {
  display: none;
  gap: 10px;
  align-items: center;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small[data-show-imgsmall='true'] {
  display: flex !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small .item-img {
  width: calc((100% - 10px) / 2);
  position: relative;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small .item-img img {
  width: 100%;
  height: auto;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small .item-img .icon-img-smal {
  position: absolute;
  top: 14px;
  left: 14px;
  width: 24px;
  height: 24px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .group-images-small .item-img .icon-img-smal img {
  width: 100%;
  height: auto;
  display: block;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .card-btn {
  display: flex;
  border-radius: 5px;
  border: solid 1px var(--bg-color-btn, #f35c5c);
  text-decoration: none;
  color: #fff;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: bold !important;
  line-height: 20px;
  align-items: center;
  column-gap: 10px;
  justify-content: center;
  transition: all 0.3s;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .card-btn:hover {
  background-color: #ffffff !important;
  color: var(--bg-color-btn, #f35c5c) !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .card-btn:hover .icon-btn {
  color: #ffffff !important;
  background-color: var(--bg-color-btn, #f35c5c) !important;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .card-btn .icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ffffff;
  color: var(--bg-color-btn, #f35c5c);
  transition: all 0.3s;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .card-btn .icon-btn svg {
  display: block;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .row-btn .sub-btn {
  font-size: 14px;
  color: #070707;
  line-height: 20px;
  color: #070707;
  margin-top: 8px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item:last-child {
  margin-bottom: 0;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-icon {
  width: 64px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-icon img {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon {
  padding-left: 20px;
  width: calc(100% - 64px);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon .title-icon {
  font-size: 15px;
  font-weight: bold;
  line-height: normal;
  color: #242424;
  margin-bottom: 3px;
}

[data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon .description-icon {
  font-size: 14px;
  line-height: normal;
  color: #6c6e72;
}

[data-type='section-card-multi-tool'] .wrap-card .card-right {
  width: 50%;
}

[data-type='section-card-multi-tool'] .wrap-card .card-right .wrap-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

[data-type='section-card-multi-tool'] .wrap-card .card-right .wrap-img img {
  display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
}

[data-type='section-card-multi-tool'] .wrap-card .card-right .wrap-video {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

[data-type='section-card-multi-tool'] .wrap-card .card-right .wrap-video video {
  display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-card-multi-tool'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-multi-tool'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-multi-tool'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left[data-style-center-y='true'] [data-attribute='card-title'] {
    text-align: center;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left {
    width: 100%;
    order: 2 !important;
    padding: 20px 16px;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h1,
  [data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h2,
  [data-type='section-card-multi-tool'] .wrap-card .card-left .card-content h3 {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
    font-size: 14px;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item {
    margin-bottom: 16px;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon {
    padding-left: 16px;
  }

  [data-type='section-card-multi-tool'] .wrap-card .card-right {
    width: 100%;
    order: 1 !important;
  }
}
`;
export default sectionCardMultiToolCss;
